import Button from '@/components/common/Button';
import React from 'react';
import styles from '../styles.module.css';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';
import { useLayoutContext } from '@/context/LayoutContext';

export default function PaymentButtons() {
  const { paymentFunction, setServerMessage } = useLayoutContext();
  const tCommon = useTranslations('common');
  return (
    <div className={styles.totalActions}>
      <Button
        className={`btn btn-ghost squareButton`}
        // onClick={() => paymentFunction && paymentFunction('inq', '')}
        onClick={() => {
          setServerMessage &&
            setServerMessage({
              type: 'error',
              text: 'امکان پرداخت خلافی تمام پلاک‌ها وجود ندارد.',
            });
        }}
      >
        <MainIcons.walletIcon width="18px" height="18px" fill="var(--paper)" />
        {tCommon('walletPay')}
      </Button>
      <Button
        className={`btn btn-primary squareButton`}
        // onClick={() => paymentFunction && paymentFunction('inq', '')}
        onClick={() => {
          setServerMessage &&
            setServerMessage({
              type: 'error',
              text: 'امکان پرداخت خلافی تمام پلاک‌ها وجود ندارد.',
            });
        }}
      >
        <MainIcons.LockIcon width="18px" height="18px" fill="var(--paper)" />
        {tCommon('onlinePay')}
      </Button>
    </div>
  );
}
